// One titled block of the studio side panel.
export function PanelSection({ label, children, testId }) {
  return (
    <section className="flex flex-col gap-3" data-testid={testId}>
      <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-zinc-500">{label}</div>
      {children}
    </section>
  );
}
